import React from 'react'
import BG from 'images/banner-background.png'
import { BannerBackgroundImg, BannerContent, BannerDescription, BannerWrapper } from './SignupBanner.styled'
import { PropsWithChildren } from 'types'

export const SignupBanner = ({ children }: PropsWithChildren) => {
  return (
    <BannerWrapper>
      <BannerContent>{children}</BannerContent>
      <BannerBackgroundImg src={BG} />
    </BannerWrapper>
  )
}

SignupBanner.Description = BannerDescription
